/*
 * @Author: wuhao
 * @Date: 2019-07-04 09:19:59
 * @LastEditors: lisf
 * @LastEditTime: 2021-04-19 10:39:06
 * @Description: API
 */
/* eslint-disable prefer-promise-reject-errors */
import axios from 'axios'
import store from '@/utils/storage'
import router from '../router'
import { Loading } from 'element-ui'
// import vuex from '../store'
import errorIntercept from '../utils/errorMessage'

let loading // 定义loading变量

function startLoading() {
  // 使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '拼命加载中……',
    background: 'rgba(255, 255, 255, 0.7)'
  })
}
function endLoading() {
  // 使用Element loading-close 方法
  loading.close()
}
// 那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
// 声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
// 调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

// 创建axios实例
const service = axios.create({
  withCredentials: false,
  // timeout: 10000000 // 请求超时时间
  timeout: 60000 // 请求超时时间
})

// request 拦截器(请求之前的操作)
service.interceptors.request.use(
  config => {
    // vuex.commit('setReqLoading', true)
    const token = store.get('token')
    // const token =
    //   'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIwMDAiLCJ1c2VyX21ldGFkYXRhIjp7ImNsaWVudHR5cGUiOiIwIiwibmFtZSI6IuiDoeePjeaWhzEiLCJ1c2VyaWQiOiJoencxIn0sImlkIjoiaHp3MSIsImV4cCI6MTYxNTk1ODI0NywiZW1haWwiOiJkZWZhdWx0QHVjc3Rhci5jb20iLCJhcHBfbWV0YWRhdGEiOm51bGx9.oy5z3rxBHyYZZn_UKyukcaKqTqoefOZPluxBDTrR8Z0'
    if (token) config.headers['token'] = token
    if (router.currentRoute.fullPath !== '/login') {
      showFullScreenLoading()
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    // if (response.data.code !== 200 && response.data.code !== 0 && response.data.code !== undefined) {
    //   Message({
    //     message: response.data.message,
    //     type: 'error',
    //     showClose: true,
    //     duration: 5 * 1000
    //   })
    //   return Promise.reject('error')
    // }
    if (errorIntercept(response.data)) {
      tryHideFullScreenLoading()
      return Promise.reject(response.data)
    }
    tryHideFullScreenLoading()
    return response.data
  },
  error => {
    if (errorIntercept(error.response.data)) {
      tryHideFullScreenLoading()
      return Promise.reject(error.response.data)
    }
    // Message({
    //   message: error.response.message,
    //   type: 'error'
    // })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js